module.exports = __webpack_public_path__ + "img/city_768.6b7b8ec6.svg";